import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { initGtm } from "./utils/gtm";

initGtm();

// Uygulamanın telefona/masaüstüne kurulabilmesi (Ana Ekrana Ekle) için service worker.
// Önbelleklemez; yalnız kurulabilirlik şartını karşılar — bkz. public/sw.js
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      // kurulum özelliği yoksa uygulama normal çalışmaya devam eder
    });
  });
}

// Tarayıcının kurulum iznini (beforeinstallprompt) EN BAŞTA yakala: olay sayfa yüklenirken
// TEK SEFER gelir; React bileşeni dinlemeye başlayana kadar beklemez. Kaçırılırsa indirme
// düğmesi doğrudan kurulum penceresi açamıyor ve yönergeye düşüyordu.
window.addEventListener("beforeinstallprompt", (event) => {
  event.preventDefault();
  window.__deferredInstallPrompt = event;
  window.dispatchEvent(new CustomEvent("installPromptReady"));
});
window.addEventListener("appinstalled", () => {
  window.__deferredInstallPrompt = null;
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
